import {
  B2BCoursePackProto,
  B2BProductOfferingProto,
} from "@noom/noom-contracts/noom_contracts/backend/enrollment/b2b/enrollment_offerings";
import { CurriculumNameProto_CurriculumName } from "@noom/noom-contracts/noom_contracts/events/app/curriculum/shared";

import { ProgramOffering } from "@/constants";

const PROGRAM_OFFERING_TO_CURRICULUM_NAME_MAP: Record<
  ProgramOffering,
  CurriculumNameProto_CurriculumName | null
> = {
  DPP: "DIABETES_PREVENTION",
  WEIGHT: "HEALTHY_WEIGHT",
  MOOD: "HEALTHY_MIND",
  DIABETES_LIFESTYLE: null,
  NMPBA: null,
  MED: null,
};

const PROGRAM_OFFERING_TO_COURSEPACK_MAP: Record<
  ProgramOffering,
  B2BCoursePackProto | null
> = {
  DPP: null,
  WEIGHT: null,
  MOOD: null,
  DIABETES_LIFESTYLE: { value: "DIABETES_SUPPORT" },
  NMPBA: { value: "NOOM_MED_POWERED_BY_ACCOLADE" },
  MED: { value: "MED" },
};

export const buildOfferingFromPrograms = (
  programs: ProgramOffering[],
): B2BProductOfferingProto => {
  let curriculumName: CurriculumNameProto_CurriculumName | null = null;
  const coursePacks: B2BCoursePackProto[] = [];
  programs.forEach((program) => {
    if (PROGRAM_OFFERING_TO_CURRICULUM_NAME_MAP[program]) {
      if (curriculumName) {
        throw new Error(
          `Multiple curriculums found for programs: ${programs.join(",")}`,
        );
      }
      curriculumName = PROGRAM_OFFERING_TO_CURRICULUM_NAME_MAP[program];
    } else {
      const cp = PROGRAM_OFFERING_TO_COURSEPACK_MAP[program];
      if (cp) {
        coursePacks.push(cp);
      }
    }
  });

  if (!curriculumName) {
    throw new Error(
      `Could not find curriculum from from programs: ${programs.join(",")}`,
    );
  }
  return {
    coursePacks,
    program: curriculumName,
  };
};
